export default "__VITE_ASSET__DwhqbYqV__"